/*
 * Havin Bag - offre « Second bag » dans le tiroir panier (17/09/2026).
 * Bloc rendu par snippets/havinbag-cart-offer.liquid. Le tiroir est re-rendu
 * par innerHTML a chaque ajout : les scripts du bloc ne s'executeraient pas,
 * d'ou ce fichier charge par layout/theme.liquid et des ecouteurs delegues
 * sur le document (jamais de noeud garde en memoire).
 * - changement de coloris : prix (barre ou non, calcule en Liquid), photo et
 *   variante du bouton suivent le choix ;
 * - « Add » : ajout AJAX avec les sections du tiroir, puis renderContents :
 *   le tiroir se met a jour et le bloc se recalcule (cache si le panier
 *   compte desormais un nombre pair de sacs de l'offre).
 */
(function () {
  if (window.__hbOfferReady) return;
  window.__hbOfferReady = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function closest(event, selector) {
    var target = event.target;
    return target && target.closest ? target.closest(selector) : null;
  }

  // Ecoute en CAPTURE et arret de la propagation (correctif du 17/09) : sans
  // ca, <cart-drawer-items> (Dawn, assets/cart.js) recoit le changement, le
  // prend pour une quantite et pose sur le menu une erreur de validation
  // (« increments of undefined ») qui bloque ensuite le bouton Check out,
  // lequel soumet le formulaire du tiroir.
  document.addEventListener('change', function (event) {
    var select = closest(event, '[data-hb-offer-select]');
    if (!select) return;
    event.stopPropagation();
    if (select.setCustomValidity) select.setCustomValidity('');
    var box = select.closest('[data-hb-offer]');
    var option = select.options[select.selectedIndex];
    if (!box || !option) return;
    var price = box.querySelector('[data-hb-price]');
    if (price) price.innerHTML = option.getAttribute('data-price-html');
    var image = box.querySelector('.hb-upsell__img');
    if (image && option.getAttribute('data-img')) image.src = option.getAttribute('data-img');
    var button = box.querySelector('[data-hb-offer-add]');
    if (button) button.setAttribute('data-hb-offer-add', select.value);
  }, true);

  document.addEventListener('click', function (event) {
    var button = closest(event, '[data-hb-offer-add]');
    if (!button) return;
    event.preventDefault();
    if (button.classList.contains('loading')) return;

    var box = button.closest('[data-hb-offer]');
    var errorWrapper = box ? box.querySelector('.product-form__error-message-wrapper') : null;
    var spinner = button.querySelector('.loading__spinner');
    var drawer = document.querySelector('cart-drawer');

    var body = { id: Number(button.getAttribute('data-hb-offer-add')), quantity: 1 };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    function showError(message) {
      if (!errorWrapper) return;
      errorWrapper.hidden = false;
      var text = errorWrapper.querySelector('.product-form__error-message');
      if (text) text.textContent = message || 'This bag could not be added. Please try again.';
    }

    button.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');
    if (errorWrapper) errorWrapper.hidden = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          showError(result.data.description || result.data.message);
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'havinbag-offer', cartData: result.data });
        }
        if (drawer && typeof drawer.renderContents === 'function' && result.data.sections) {
          drawer.renderContents(result.data);
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () {
        showError();
      })
      .finally(function () {
        button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  });
})();
